var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_427_5025",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.123779,
    width: 18.566,
    height: 13.1321,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_427_5025)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -0.310303,
    width: 19,
    height: 13,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_427_5025",
    transform: "scale(0.0243902 0.0344828)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_427_5025",
    width: 41,
    height: 29,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAdCAYAAAA3i0VNAAAE20lEQVRYhc2YXWgcVRiG3+9MUqtYiJXUnSQX0jsVvdCLCq2IraVoSxJsNqS16U+6OzNJBG+89GIQ6Y1QRSW7s5Oa1lTRFFFEChWKVInWvwotNbUqCM3uxBbTKCgk2TmvF5lZhpjfNk38rnbf8/ecd74532EEURQKhW0icgzAPVjhIHlhcnLyme7u7l8AwIgbVq9e/dv69euHRGQbgDtWELAoIm2O41yMNfF9/7FisTjouq4GAM/zmpVSeayAoyQvkWy1bfsCALiuW1VbW/uoIvmuaZqPxx2DIPhYRJ4F8McyM14Jw3B3DAgApmnur66ufkl839ckAxHZXywWT8eOFgqFnSKSA1C7DIBDExMTO7u7u4cAwPO8aqVUC4A3AVxWAERETJJ9qVRqQzyqpqbmI5LtuPWOlkjuiwGjOACgF8BaYConGbeQLJJsD4LgzDRHfQB33QLAIa31Htu2zwEVB5tIFkQkXu+sSo4QkXql1PF169ZtrGyzVPoQQAuA0SUGHAbQFgMCAMm9AI4mAKe4kk4mIiC5N5vNnhYRAoDneWmlVA7A3UsAOASgLZvNno/mrgawW0RenQ6I6U4mwgRwJJfLPVyhDoIPALQCGLtJwJLWek8MCABKqRYR6ZkBEMDsTsYxorXO2LZ9EgABoFAotIqIB6DmBgDPa60PxI/Ydd1V9fX17SRfmQ0QczgZR0op1ZvL5R6IBcuyTojIDpLXFwlYCsNwVzIHTdPcRfL1OQABAPNBAkCqqqrqlO/7WwEIAGYymUEADsk/Fwh4KQzDFsdxfgSmctD3/YNRDs5bghcCCQB1AN7J5/MPxYJlWQMkd2CeHCVZDMOw0XGcrxJyGsCsOXijkABQq5Tq7+npqUxs2/YgSXuOR39Za93sOM7PseD7foNS6mUAqxa68GIgr2mt27u6upJAjBxtJPlXsjPJQGvd5DjOd0k9m80Oa61fBDCx1JC/k+xwHKdybBw+fHht/Nu27UEAz0WOEsBPYRimbdu+BEzdZnp7e9cm5jtB8oWF5vRCIEfK5fKTlmV9EgGI53mb1qxZ86XneQ8iepksy+ofHx9/pFwu2+Pj4xs7OzsHAYCk1NfXp7XWZ/P5/P3RpiYty3qD5PMk/5kP4KbOyajWd9i2/elMg13XrTJNM6uUOoSpc/WGzsm5IEfK5XJTZ2fnN4kNbSB5MjkhyQBAU01NzbnW1tYw1qNS16yUegvAnYl5h8Mw3BYfR1HffUopD8Bti4FcbO3+G8Apkp8rpa6RvBfAZpKbRGSmhRdVu2eCLE1OTrZ1dXV9AQCu66pUKvWEYRgDiO53SxTDALYna7jv+wejCpQ84P9TFgOSmatXrw7GQkNDw3bDMN5fYkAAaADQ7/t+pUAUi8V+kl3T3/qKkySLWut0XBkGBgaM0dHRrYZhHMfSXM9mixLJZsuyvo0F3/ctkq+JyO2InGTUsWNkZOTruOPY2FizYRhv32JAAKgTkWO+798XC1rrPpIZANcBQAqFwhWSe23b/gyYysG6urrNIvLeMgAmY1hEGjOZzA+x4HmeJSK7lIh0BEFwJm4wTfOp6EvGcgICQAPJo0lHAfRprQ9J/C+dThtbtmx52jCMvhUATEYJQGM2m/0+FiqQ+Xx+q2EYR/A/+BYE4KLWOm3b9q8A8C+UwofZko+L0QAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendmail);
export default __webpack_public_path__ + "static/media/sendmail.f4292deaf18cdcc1fb38b0ecfa06d50e.svg";
export { ForwardRef as ReactComponent };